(function() {
  if (window.__nnCardAddInit) return;
  window.__nnCardAddInit = true;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.nn-card-add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var hasOptions = btn.getAttribute('data-nn-has-options') === 'true';
    var productUrl = btn.getAttribute('data-nn-product-url');
    var variantId = btn.getAttribute('data-nn-add-to-cart');

    if (hasOptions && productUrl) {
      window.location.href = productUrl;
      return;
    }
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    var sectionsToRender = ['cart-icon-bubble'];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.id) sectionsToRender.push(drawer.id);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionsToRender.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status) throw new Error(data.description || data.message || 'Error');

        if (data.sections) {
          var bubbleHtml = data.sections['cart-icon-bubble'];
          if (bubbleHtml) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              var tmp = document.createElement('div');
              tmp.innerHTML = bubbleHtml;
              var newBubble = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild;
              if (newBubble) bubble.innerHTML = newBubble.innerHTML;
            }
          }
          if (drawer && data.sections[drawer.id]) {
            drawer.renderContents({ sections: data.sections, items: [] });
          }
        }

        try {
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nn-card-add', productVariantId: variantId });
          }
        } catch (_) {}

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.disabled = false;
        setTimeout(function() { btn.classList.remove('is-added'); }, 1500);
      })
      .catch(function(err) {
        console.warn('[nn-card-add]', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (productUrl) window.location.href = productUrl;
      });
  }, true);
})();
